export const DEFAULT_ERROR_MESSAGE_TIMEOUT_SECONDS = 10;
export const STACK_STATUS_LIVE = 'Live';
export const STACK_STATUS_PREVIEW = 'Preview';

export const SUPPORT_EMAIL = 'support@gofisherman.com';
export const MAIL_TO_SUPPORT_EMAIL = `mailto:${SUPPORT_EMAIL}`;

export const GLAMMATIC_SUPPORT_EMAIL = 'help@glammatic.com';
export const GLAMMATIC_MAIL_TO_SUPPORT_EMAIL = `mailto:${GLAMMATIC_SUPPORT_EMAIL}`;

export const RESTAURANT_BUSINESS_TYPE = 'restaurant';
export const GENERIC_BUSINESS_TYPE = 'generic';
export const MERCHANT_BUSINESS_TYPE = 'merchant';

export const HELP_CENTER_URL = 'https://gofisherman.zendesk.com/hc/en-us';

export const DEFAULT_EXTERNAL_ANCHOR_REL = 'noopener noreferrer';
export const DEFAULT_EXTERNAL_ANCHOR_TARGET = '_blank';
export const DEFAULT_EXTERNAL_OPEN_FEATURES = 'noopener,noreferrer';

export const V_LEGACY_KEY = 'v_legacy';

// Merchant Categories
export const RESTAURANT_CATEGORY = 'Restaurant';
export const SPA_CATEGORY = 'Spa';
export const SALON_CATEGORY = 'Salon';
export const HAIR_CATEGORY = 'Hair Care';
export const BARBERSHOP_CATEGORY = 'Barbershop';
export const SKIN_CARE_CATEGORY = 'Skin Care';
export const NAIL_CARE_CATEGORY = 'Nail Care';
export const MAKEUP_CATEGORY = 'Makeup';
export const BUSINESS_CATEGORY = 'Business';
export const ENTERTAINMENT_CATEGORY = 'Entertainment';
export const TATTOO_PARLOR_CATEGORY = 'Tattoo Parlor';

export const STAFF_CATEGORIES = [
  SALON_CATEGORY,
  SPA_CATEGORY,
  HAIR_CATEGORY,
  BARBERSHOP_CATEGORY,
  SKIN_CARE_CATEGORY,
  NAIL_CARE_CATEGORY,
  MAKEUP_CATEGORY,
];

export const ARTISTS_CATEGORIES = [TATTOO_PARLOR_CATEGORY];

export const BEAUTY_CATEGORIES = [...STAFF_CATEGORIES, ...ARTISTS_CATEGORIES];

export const SERVICE_MENU_CATEGORIES = [
  ...BEAUTY_CATEGORIES,
  BUSINESS_CATEGORY,
  ENTERTAINMENT_CATEGORY,
];

const mapCategoriesToValue = (categories, value) =>
  Object.fromEntries(categories.map((category) => [category, value]));

export const SERVICE_MENU_NAME_BY_CATEGORY = {
  ...mapCategoriesToValue(SERVICE_MENU_CATEGORIES, 'Services'),
  [RESTAURANT_CATEGORY]: 'Menu',
};

export const SERVICE_MENU_ICON_BY_CATEGORY = {
  ...mapCategoriesToValue(SERVICE_MENU_CATEGORIES, 'clipboard list'),
  [RESTAURANT_CATEGORY]: 'food',
};
